import { DataGrid, type GridColDef } from '@mui/x-data-grid'
import React from 'react'
import { Box, Grid } from '@mui/material'
import { type EditSolarPlantComponentProps } from './EditSolarPlantForm'

interface SolarProjectMonitoringAssetAndStatus {
  rowId: string
  monitoringAssetId: number
  monitoringSourceCode: string
  externalAssetName: string
  externalAssetId: string
  disabledAtFormatted: string
  metricCategory: string
  lastHistoricalSyncAtFormatted: string
  lastSyncAtFormatted: string
}

const ViewMonitoringAssets: React.FC<EditSolarPlantComponentProps> = ({ solarProject }: EditSolarPlantComponentProps) => {
  const flattenAssets = (): SolarProjectMonitoringAssetAndStatus[] => {
    const fa: SolarProjectMonitoringAssetAndStatus[] = []

    for (const asset of solarProject.monitoringAssets) {
      for (const status of asset.syncStatuses) {
        fa.push({
          rowId: `${asset.monitoringAssetId}-${status.metricCategory}`,
          monitoringAssetId: asset.monitoringAssetId,
          monitoringSourceCode: asset.monitoringSourceCode,
          externalAssetName: asset.externalAssetName,
          externalAssetId: asset.externalAssetId,
          disabledAtFormatted: asset.disabledAtFormatted,
          metricCategory: status.metricCategory,
          lastHistoricalSyncAtFormatted: status.lastHistoricalSyncAtFormatted,
          lastSyncAtFormatted: status.lastSyncAtFormatted
        })
      }
    }
    return fa
  }

  const assets = flattenAssets()

  const columns: GridColDef[] = [
    { field: 'monitoringAssetId', headerName: 'Project ID', flex: 10 },
    { field: 'monitoringSourceCode', headerName: 'Monitoring Source', flex: 15 },
    { field: 'externalAssetName', headerName: 'Asset Name', flex: 20 },
    { field: 'externalAssetId', headerName: 'Asset ID', flex: 25 },
    { field: 'disabledAtFormatted', headerName: 'Disabled at', flex: 15 },
    { field: 'metricCategory', headerName: 'Metric Category', flex: 15 },
    { field: 'lastHistoricalSyncAtFormatted', headerName: 'Last Historical Sync', flex: 15 },
    { field: 'lastSyncAtFormatted', headerName: 'Last  Sync', flex: 15 }
  ]

  return (
    <>
      <Box sx={{ pb: 4 }}>
        <h3>Monitoring Assets</h3>

        <Grid container spacing={4} >
          <Grid item md={12}>
            <DataGrid
              rows={assets}
              getRowId={(row) => row.rowId}
              columns={columns}
              autoHeight={true}
              disableSelectionOnClick
              pagination
              pageSize={15}
              rowsPerPageOptions={[15]}
            />

          </Grid>
        </Grid>

      </Box>
    </>
  )
}

export default ViewMonitoringAssets
